import request from "@/utils/http/requset";

function getPayInList(data) {
  return request({
    url: "/manage/payin/search",
    method: "post",
    ContentType: "application/json;charset=UTF-8",
    data: data
  });
}
function getPayInSearchDownload(data) {
  return request({
    url: "/manage/payin/search/download",
    method: "post",
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      "Accept": "application/json, text/plain, */*"
    },
    data: data,
    responseType: "blob",
    timeout: 30000
  });
}
export default {
  getPayInList,
  getPayInSearchDownload,
};
